var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 44",
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.486 6.979a1.5 1.5 0 0 0-1.047.46L24 21.88 9.56 7.439a1.5 1.5 0 0 0-1.076-.455A1.5 1.5 0 0 0 7.44 9.561L21.88 24 7.439 38.44a1.5 1.5 0 1 0 2.122 2.12L24 26.122l14.44 14.44a1.5 1.5 0 1 0 2.12-2.122L26.122 24l14.44-14.44a1.5 1.5 0 0 0-1.075-2.581z"
  })));
};
export default SvgClose;